import { Typography } from "@mui/material";

import { Box } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltip from "../../../../components/CustomTooltip";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { severities } from "../../../stack/environment/icons/iconExport";

const CustomLegendItem = ({ item, highlightedItem, onHover }) => {
  const colors = useColors();
  const itemToHighlight = {
    dataIndex: item.id,
    seriesId: "pie-segment",
  };

  return (
    <Box
      onMouseEnter={() => onHover && onHover(itemToHighlight)}
      onMouseLeave={() => onHover && onHover(null)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
        opacity:
          highlightedItem === null || highlightedItem?.dataIndex === item.id
            ? 1
            : 0.5,
        transition: "opacity 0.2s ease",
      }}
    >
      <Box
        sx={{
          width: 12,
          height: 12,
          minWidth: 12,
          minHeight: 12,
          borderRadius: "3px",
          backgroundColor: item.color,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: colors.text_secondary,
        }}
      >
        {item.label}
      </Typography>
      {item.tooltip && (
        <CustomTooltip
          title={
            <item.tooltip othersNames={item.othersNames} color={item.color} />
          }
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SvgToIcon
              IconLogo={severities.SeverityInfoTooltipIcon}
              width="16px"
              height="16px"
            />
          </Box>
        </CustomTooltip>
      )}
    </Box>
  );
};

export default CustomLegendItem;
